/* =====================================================================
 * BrandMark — logo orizzontale (`public/logo.svg`) per angoli schermate
 * partecipante / generating / winner. `tone` è ignorato (logo a colori).
 * ===================================================================== */

interface BrandMarkProps {
  className?: string;
  /** @deprecated non più usato (id SVG unici non servono con asset esterno) */
  cubeUid?: string;
  tone?: 'light' | 'dark';
}

export default function BrandMark({ className, tone: _tone = 'light', cubeUid: _cubeUid }: BrandMarkProps) {
  return (
    <div className={className} style={{ lineHeight: 0, display: 'inline-block' }}>
      <img
        src="/logo.svg"
        alt=""
        aria-hidden
        decoding="async"
        style={{
          display: 'block',
          height: 'clamp(26px, 5vw, 36px)',
          width: 'auto',
          maxWidth: 'min(46vw, 240px)',
        }}
      />
    </div>
  );
}
